const cv = require("./Manik CV.pdf");

export { cv };
